import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-chevron-right.tsx
/**
* icon.16.chevron.right
*
* Keywords: arrow, forward, next, direction, navigation, pointer, advance
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTYuNzY4IDUuNTI1YS41LjUgMCAwIDEgLjcwNyAwbDIuMTIxIDIuMTIxYS41LjUgMCAwIDEgMCAuNzA3bC0yLjEyMSAyLjEyMmEuNS41IDAgMCAxLS43MDctLjcwOEw4LjUzNSA4IDYuNzY4IDYuMjMyYS41LjUgMCAwIDEgMC0uNzA3Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11746
*/
const Icon16ChevronRight = memo(function Icon16ChevronRight(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M6.768 5.525a.5.5 0 0 1 .707 0l2.121 2.121a.5.5 0 0 1 0 .707l-2.121 2.122a.5.5 0 0 1-.707-.708L8.535 8 6.768 6.232a.5.5 0 0 1 0-.707"
		})
	});
});
//#endregion
export { Icon16ChevronRight };

//# sourceMappingURL=icon-16-chevron-right.js.map